module.exports = __webpack_public_path__ + "img/IMG_1067.5fb22219.png";